// SLA por etapa (em horas) — espelha a resolução do backend (Task 1:
// Funnel#sla_hours_for_stage / #deal_age_status) para o card do kanban.

const DEFAULT_MAX_DAYS_IN_STAGE = 14;
const HOURS_PER_DAY = 24;

// Prazo (em horas) da etapa: `sla_hours` explícito manda; senão cai para
// `max_days_in_stage` convertido em horas; sem nenhuma config, default de
// 14 dias (336h) — mesma cascata do model Funnel no backend.
export function slaHoursForStage(stageConfig = {}) {
  return (
    stageConfig?.sla_hours ||
    (stageConfig?.max_days_in_stage || DEFAULT_MAX_DAYS_IN_STAGE) *
      HOURS_PER_DAY
  );
}

// Formata uma duração em horas para exibição compacta no selo do card:
// menos de 1 dia → '2h'; múltiplo exato de 24h → '2d'; resto → '2d 3h'.
export function formatDuration(hours) {
  const totalHours = Math.max(0, Math.floor(hours));
  const days = Math.floor(totalHours / HOURS_PER_DAY);
  const remainingHours = totalHours % HOURS_PER_DAY;

  if (days === 0) return `${remainingHours}h`;
  if (remainingHours === 0) return `${days}d`;
  return `${days}d ${remainingHours}h`;
}

// Status do aging conforme percentual do SLA consumido — mesmos limiares
// (50/80/100%) do backend (Funnel#deal_age_status).
export function agingStatus(hoursInStage, slaHours) {
  if (!slaHours || slaHours <= 0) return 'healthy';

  const percentage = (hoursInStage / slaHours) * 100;

  if (percentage >= 100) return 'critical';
  if (percentage >= 80) return 'danger';
  if (percentage >= 50) return 'warning';
  return 'healthy';
}
